import React, { useEffect, useState } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useTranslate } from 'react-admin';
import { db } from '../../database/firebase';
import { getDoc, doc } from 'firebase/firestore';
import { apiGet, useApiData } from '../../services/apiClient';

const OrganisatorInformation = ({ event }) => {
  const translate = useTranslate();
  const [venueData, setVenueData] = useState(null);
  const [organisatorCompaniesData, setOrganisatorCompaniesData] = useState([]);

  const venueID = event?.venue ?? null;
  const organisationCompanies = event?.organisationCompanies ?? [];

  useEffect(() => {
    let cancelled = false;

    const loadVenue = async () => {
      if (!venueID) return;
      try {
        if (useApiData) {
          const venue = await apiGet(`venues/${encodeURIComponent(venueID)}`);
          if (!cancelled) setVenueData(venue);
          return;
        }
        const venueSnap = await getDoc(doc(db, 'venues', venueID));
        if (!cancelled) setVenueData(venueSnap.exists() ? venueSnap.data() : null);
      } catch (error) {
        console.error('Error loading venue:', error);
      }
    };

    const loadCompanies = async () => {
      if (!organisationCompanies.length) return;
      const companies = [];
      for (const companyID of organisationCompanies) {
        try {
          if (useApiData) {
            const company = await apiGet(
              `organisationCompanies/${encodeURIComponent(companyID)}`,
            );
            companies.push(company);
          } else {
            const companySnap = await getDoc(doc(db, 'organisationCompanies', companyID));
            if (companySnap.exists()) companies.push(companySnap.data());
          }
        } catch (error) {
          if (error.status !== 404) {
            console.error('Error loading organisation company:', error);
          }
        }
      }
      if (!cancelled) setOrganisatorCompaniesData(companies);
    };

    loadVenue();
    loadCompanies();

    return () => {
      cancelled = true;
    };
  }, [venueID, organisationCompanies.join(',')]);

  return (
    <Container maxWidth="lg" style={{ marginTop: 16, marginBottom: 16 }}>
      <Typography variant="h6" style={{ marginBottom: 12 }}>
        {translate('report.venue_organisator_details', { _: 'Venue / Organisator Details' })}
      </Typography>
      <Box style={{ display: 'flex', gap: 32, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="subtitle2">{translate('report.venue', { _: 'Mekan' })}</Typography>
          <Typography variant="body1">{venueData ? venueData.name : '-'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">{translate('report.address', { _: 'Adres' })}</Typography>
          <Typography variant="body1">{venueData ? venueData.address : '-'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">{translate('report.organisator_companies', { _: 'Organizasyon Şirketleri' })}</Typography>
          <Box>
            {organisatorCompaniesData.map((company, i) => (
              <span key={company?.id ?? i} style={{ marginRight: 8 }}>
                {company.name}
              </span>
            ))}
            {organisatorCompaniesData.length === 0 && <span>N/A</span>}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default OrganisatorInformation;
